import { Controller } from "@hotwired/stimulus"
import { Tab } from "bootstrap"

// Order / Features / Coming Soon tabs inside a GOAT Store order dialog (#13900;
// Order first and lit by default since 2026-09-28).
// The tabs themselves are Bootstrap pills on the shared `.gl-haml-tab--slate`
// anatomy (the in-modal pattern win_back_customers/_email_stats_modal uses);
// this controller only (1) shows the footer actions that belong to the lit tab
// (`data-store-order-tabs-for="features|coming_soon|order"`, several values
// space-separated) and (2) lets "Continue to Order" switch to the Order tab.
// Nothing here submits, charges or fetches; the coupon field lives in the Order
// pane and keeps its value because panes are hidden, never re-rendered.
export default class extends Controller {
  static targets = ["tab", "footerAction"]

  connect() {
    this.onShown = this.onShown.bind(this)
    this.element.addEventListener("shown.bs.tab", this.onShown)
    this.syncFooter(this.activeKey())
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.tab", this.onShown)
  }

  onShown(event) {
    const key = event.target?.dataset?.storeOrderTabsKey
    if (key) this.syncFooter(key)
  }

  // data-action="click->store-order-tabs#goTo" data-store-order-tabs-key-param="order"
  goTo(event) {
    event.preventDefault()
    const key = event.params?.key
    const tab = this.tabTargets.find((el) => el.dataset.storeOrderTabsKey === key)
    if (!tab) return
    Tab.getOrCreateInstance(tab).show()
    tab.focus()
  }

  activeKey() {
    const active = this.tabTargets.find((el) => el.classList.contains("active"))
    return active?.dataset?.storeOrderTabsKey || this.tabTargets[0]?.dataset?.storeOrderTabsKey
  }

  syncFooter(key) {
    this.footerActionTargets.forEach((el) => {
      const keys = (el.dataset.storeOrderTabsFor || "").split(/\s+/).filter(Boolean)
      el.hidden = keys.length > 0 && !keys.includes(key)
    })
  }
}
